module.exports = __webpack_public_path__ + "hyperion-v2-static/img/pulse-score-graphic.2088b446.png";